module.exports = __webpack_public_path__ + "img/footer1.c40354fa.png";